import type { paymentServicesTypes, ManualIncentiveEntry } from '@makemydeal/dr-platform-types';
import type { ManualIncentiveEditEntry } from '@makemydeal/dr-dash-store/types/manualIncentiveTypes';
import { isOriginalIncentive } from '@makemydeal/dr-dash-store/utils/manualIncentivesUtils';

import { NON_MANUAL_INCENTIVE_DISPLAY_TYPES, INCENTIVE_TYPE_VALUES } from '@makemydeal/dr-dash-types';

export type IIncentiveTypeMappingInputs = {
    code?: number;
    isStandardIncentive?: boolean;
    type?: paymentServicesTypes.IncentiveType | '';
    description?: string;
    name: string;
};

const isDealerCashType = (data: ManualIncentiveEntry | ManualIncentiveEditEntry): boolean =>
    data.type === INCENTIVE_TYPE_VALUES.dealerCash.value;

const getUserCustomDisplayType = (data: ManualIncentiveEntry | ManualIncentiveEditEntry): string =>
    isDealerCashType(data) ? INCENTIVE_TYPE_VALUES.dealerCash.label : INCENTIVE_TYPE_VALUES.customerCash.label;

export const getIncentiveDisplayType = (
    data: ManualIncentiveEntry | ManualIncentiveEditEntry,
    isProgramIncentivesRestorationEnabled = false
): string => {
    const conditionalIncentiveLabel = isProgramIncentivesRestorationEnabled
        ? NON_MANUAL_INCENTIVE_DISPLAY_TYPES.conditional
        : NON_MANUAL_INCENTIVE_DISPLAY_TYPES.included;

    if (isProgramIncentivesRestorationEnabled && data.manual === true) {
        return getUserCustomDisplayType(data);
    }

    if (data.isStandardIncentive) {
        return NON_MANUAL_INCENTIVE_DISPLAY_TYPES.manufacturer;
    } else if (data.type === INCENTIVE_TYPE_VALUES.dealerCash.value) {
        return INCENTIVE_TYPE_VALUES.dealerCash.label;
    } else if (isOriginalIncentive(data)) {
        return conditionalIncentiveLabel;
    } else if (data.type === INCENTIVE_TYPE_VALUES.customerCash.value) {
        return INCENTIVE_TYPE_VALUES.customerCash.label;
    }

    // Returns in case when the rebate is not known for MV but came from other system
    return conditionalIncentiveLabel;
};
